module.exports = __webpack_public_path__ + "img/sample-report-16@3x.aa2ce684.png";